export const getRequiredLabel = (label: string) => `* ${label}`;
